<div class="get-labels-shipment-details" data-testid="get-labels-shipment-details">
  <div class="get-labels-shipment-details__cards">
    <div class="get-labels-shipment-details__card-row">
      <app-review-address-summary kind="shipFrom" [address]="shipFromView()" [showEdit]="false" />
      <app-review-address-summary kind="shipTo" [address]="shipToView()" [showEdit]="false" />
      <app-review-address-summary
        kind="returnTo"
        [returnAddress]="returnView()"
        [showEdit]="false"
      />
    </div>
    @if (packagingView() || additionalServicesView() || inductionView()) {
      <div class="get-labels-shipment-details__card-row">
        @if (packagingView(); as packaging) {
          <app-review-packaging-summary [view]="packaging" [showEdit]="false" />
        }
        @if (additionalServicesView(); as additional) {
          <app-review-additional-services-summary [view]="additional" [showEdit]="false" />
        }
        @if (inductionView(); as induction) {
          <app-review-induction-summary
            [view]="induction"
            [locatorUrl]="locatorUrl()"
            [showEdit]="false"
          />
        }
      </div>
    }
  </div>
</div>
